"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _theme = require("../../theme");

_theme.theme.progressBarSizes = {
  small: {
    height: '5px'
  },
  medium: {
    height: '12px'
  }
};
var ProgressBarSizes = (0, _styledSystem.variant)({
  scale: 'progressBarSizes',
  prop: 'size'
});
var StyledProgressBar = (0, _styledComponents.default)('div').withConfig({
  displayName: "ProgressBar__StyledProgressBar",
  componentId: "y88aev-0"
})(["", " ", " ", " position:inherit;width:100%;"], ProgressBarSizes, _styledSystem.color, _styledSystem.background);
var StyledProgressBarValue = (0, _styledComponents.default)('div').withConfig({
  displayName: "ProgressBar__StyledProgressBarValue",
  componentId: "y88aev-1"
})(["", " ", " ", " height:inherit;width:", "%;transition:width 0.5s ease-in-out;"], _styledSystem.border, _styledSystem.color, _styledSystem.background, function (props) {
  return props.percent;
});

var ProgressBar = function ProgressBar(_ref) {
  var percent = _ref.percent,
      size = _ref.size,
      isTransparent = _ref.isTransparent,
      isBordered = _ref.isBordered,
      progressBarValueColor = _ref.progressBarValueColor,
      progressBarColor = _ref.progressBarColor;
  return _react.default.createElement(StyledProgressBar, {
    size: size,
    isTransparent: isTransparent,
    position: "inherit",
    backgroundColor: isTransparent ? 'transparent' : progressBarColor
  }, _react.default.createElement(StyledProgressBarValue, {
    percent: percent,
    backgroundColor: progressBarValueColor,
    borderBottomLeftRadius: isBordered && 1,
    borderBottomRightRadius: isBordered && 1
  }));
};

exports.ProgressBar = ProgressBar;
ProgressBar.defaultProps = {
  percent: 0,
  size: 'medium',
  isTransparent: false,
  isBordered: false,
  progressBarColor: 'ghosted.sonar.light',
  progressBarValueColor: 'quandog'
};